import classnames from 'classnames';
import React, { FC, useCallback } from 'react';
import { ModalName } from '../../../../../../constants/ModalName';
import { ActionClickOrigin } from '../../../../../../utils/hooks/bi/useTrackActions/useTrackActions.types';
import {
  TrackBoardActionsMenuClickOrigin,
  TrackBoardActionsMenuTarget,
  useTrackBoardAnalytics,
} from '../../../../../../utils/hooks/bi/useTrackBoardAnalytics';
import { useModalHandlersAndOptions } from '../../../../../../utils/hooks/useModal';
import { isSystemBoard } from '../../../../../../utils/media-manager-sdk/boards';
import { CloseButton, WixIcons } from '../../../../../../components/common';
import { BoardThumbnail } from '../../../../../../components/common/Thumbnails';
import styles from '../Thumbnails.scss';
import { IOuter } from './Board.types';

export const Board: FC<IOuter> = ({ item }) => {
  const isEditableBoard = !isSystemBoard(item);
  const { openModal: openEditBoardModal } = useModalHandlersAndOptions(ModalName.EditBoard);
  const { trackBoardActionsClick } = useTrackBoardAnalytics();

  const handleEditBoardClick = useCallback(() => {
    if (!isEditableBoard) {
      return;
    }

    openEditBoardModal({ board: item, clickOrigin: ActionClickOrigin.File });

    trackBoardActionsClick([item], {
      target: TrackBoardActionsMenuTarget.Edit,
      clickOrigin: TrackBoardActionsMenuClickOrigin.InfoPanel,
    });
  }, [item, openEditBoardModal, trackBoardActionsClick, isEditableBoard]);

  return (
    <div
      className={classnames(styles.boardThumbnailWrapper, { [styles.isEditableBoard]: isEditableBoard })}
      onClick={handleEditBoardClick}
      data-hook="single-board-top-part"
    >
      <BoardThumbnail
        board={item}
        className={styles.boardThumbnailImageWrapper}
        imageClassName={styles.boardThumbnailImage}
        width={232}
        height={150}
      />

      {isEditableBoard && (
        <CloseButton className={styles.boardEditButton} size="medium" skin="standardFilled">
          <WixIcons.Edit />
        </CloseButton>
      )}
    </div>
  );
};
